(function () {
  // Reveal animation on scroll (Intersection Observer)
  const revealObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('v');
      }
    });
  }, {
    threshold: 0.06,
    rootMargin: '0px 0px -60px 0px'
  });
  
  document.querySelectorAll('.rv, .img-rv').forEach(el => revealObserver.observe(el));

  // Parallax scroll effect
  const parItems = document.querySelectorAll('.par-img');
  function updateParallax() {
    const vh = window.innerHeight;
    parItems.forEach(el => {
      const parent = el.parentElement;
      if (!parent) return;
      const rect = parent.getBoundingClientRect();
      if (rect.top < vh && rect.bottom > 0) {
        const speed = parseFloat(el.dataset.speed || 0.1);
        const yPos = (rect.top - vh / 2) * speed;
        el.style.transform = 'translateY(' + yPos + 'px) scale(1.15)';
      }
    });
  }
  
  if (parItems.length > 0) {
    window.addEventListener('scroll', () => {
      requestAnimationFrame(updateParallax);
    }, { passive: true });
    updateParallax();
  }

  // Sticky Nav (Chapters)
  const nav = document.getElementById('corteNav');
  if (nav) {
    const links = nav.querySelectorAll('.corte-nav-link');
    const sections = Array.from(document.querySelectorAll('.corte-chap[id]'));

    const spacer = document.createElement('div');
    spacer.className = 'corte-nav-spacer';
    spacer.style.cssText = 'height:0;display:none';
    nav.parentNode.insertBefore(spacer, nav);

    let navOffsetTop = 0, navHeight = 0;
    let isMobile = window.innerWidth < 760;

    function measure() {
      isMobile = window.innerWidth < 760;
      const wasStuck = nav.classList.contains('stuck');
      nav.classList.remove('stuck');
      spacer.style.display = 'none';
      navOffsetTop = nav.getBoundingClientRect().top + window.pageYOffset;
      navHeight = nav.offsetHeight;
      if (wasStuck) {
        nav.classList.add('stuck');
        spacer.style.cssText = 'display:block;height:' + navHeight + 'px';
      }
    }
    measure();
    window.addEventListener('resize', measure);

    links.forEach(link => {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        const target = this.dataset.target;
        const el = document.getElementById(target);
        if (el) {
          const offset = isMobile ? 80 : (120 + navHeight + 20);
          const top = el.getBoundingClientRect().top + window.pageYOffset - offset;
          window.scrollTo({ top: top, behavior: 'smooth' });
        }
      });
    });

    function updateNav() {
      const scrollY = window.scrollY;

      if (isMobile) {
        const intro = document.querySelector('.corte-intro');
        const introBottom = intro ? intro.offsetTop + intro.offsetHeight : 400;
        if (scrollY > introBottom - 100) {
          if (!nav.classList.contains('stuck')) {
            nav.classList.add('stuck');
            spacer.style.cssText = 'display:block;height:' + navHeight + 'px';
          }
        } else if (nav.classList.contains('stuck')) {
          nav.classList.remove('stuck');
          spacer.style.cssText = 'display:none;height:0';
        }
      } else {
        const threshold = navOffsetTop - 120;
        if (scrollY > threshold) {
          if (!nav.classList.contains('stuck')) {
            nav.classList.add('stuck');
            spacer.style.cssText = 'display:block;height:' + navHeight + 'px';
          }
        } else if (nav.classList.contains('stuck')) {
          nav.classList.remove('stuck');
          spacer.style.cssText = 'display:none;height:0';
        }
      }

      const firstSection = sections[0];
      if (firstSection) {
        const firstTop = firstSection.getBoundingClientRect().top + window.pageYOffset;
        if (scrollY < firstTop - 200) {
          links.forEach(l => l.classList.remove('active'));
          return;
        }
      }
      let currentSection = null;
      for (const sec of sections) {
        const rect = sec.getBoundingClientRect();
        if (rect.top <= 250 && rect.bottom > 250) {
          currentSection = sec;
          break;
        }
      }
      if (currentSection) {
        const id = currentSection.id;
        links.forEach(l => l.dataset.target === id ? l.classList.add('active') : l.classList.remove('active'));
      }
    }

    let ticking = false;
    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(() => { updateNav(); ticking = false; });
        ticking = true;
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    setTimeout(() => { measure(); updateNav(); }, 100);
  }

  // Video playback on click
  document.querySelectorAll('.corte-video').forEach(videoBox => {
    videoBox.addEventListener('click', function () {
      const videoId = this.dataset.videoId;
      if (!videoId) return;
      
      const iframe = document.createElement('iframe');
      iframe.src = 'https://www.youtube.com/embed/' + videoId + '?autoplay=1&rel=0';
      iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
      iframe.allowFullscreen = true;
      
      this.innerHTML = '';
      this.appendChild(iframe);
    });
  });
})();
